var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 26,
    viewBox: "0 0 31 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 3.69878C29.3968 4.18764 28.2116 4.51795 26.9657 4.66725C28.2513 3.89801 29.213 2.68733 29.6716 1.2611C28.4638 1.97852 27.1419 2.4835 25.7634 2.7541C24.8364 1.76431 23.6085 1.10827 22.2704 0.887815C20.9324 0.667364 19.559 0.89484 18.3634 1.53493C17.1679 2.17502 16.2171 3.1919 15.6588 4.42771C15.1004 5.66352 14.9656 7.04911 15.2754 8.36935C12.828 8.24647 10.4339 7.61037 8.24829 6.50232C6.0627 5.39427 4.13451 3.83904 2.58888 1.93757C2.06038 2.84923 1.7565 3.90621 1.7565 5.03191C1.75591 6.04529 2.00546 7.04315 2.48302 7.93695C2.96057 8.83076 3.65136 9.59287 4.4941 10.1557C3.51675 10.1246 2.56096 9.86048 1.70629 9.38538V9.46466C1.70619 10.886 2.19783 12.2635 3.09779 13.3636C3.99775 14.4637 5.2506 15.2186 6.64375 15.5001C5.7371 15.7454 4.78654 15.7816 3.86387 15.6058C4.25693 16.8287 5.02259 17.8981 6.05364 18.6643C7.0847 19.4305 8.32954 19.8551 9.61389 19.8786C7.43363 21.5902 4.74102 22.5186 1.96922 22.5145C1.47822 22.5146 0.987637 22.486 0.5 22.4286C3.31354 24.2376 6.58871 25.1977 9.93363 25.194C21.2566 25.194 27.4466 15.8158 27.4466 7.68231C27.4466 7.41806 27.44 7.15117 27.4281 6.88692C28.6322 6.0162 29.6715 4.93796 30.4974 3.70274L30.5 3.69878Z",
    fill: "url(#paint0_linear_248_1337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_1337",
    x1: 0.5,
    y1: 13.8129,
    x2: 30.5,
    y2: 13.8129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAC01E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC762A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.99b93e3438fecfa6ca5860910f8ec019.svg";
export { ForwardRef as ReactComponent };